export const parseFeatures = async (features, name) => {
  const feature = features.find((e) => e.name === name);
  return feature;
};
